import { cn } from '@/lib/utils/cn.js';

export type IconName =
  | 'home' | 'search' | 'wallet' | 'gift' | 'history' | 'user' | 'logout'
  | 'arrowDown' | 'arrowUp' | 'arrowRight' | 'close' | 'menu' | 'bell'
  | 'star' | 'play' | 'cherry' | 'spade' | 'fish' | 'video' | 'trendUp'
  | 'ticket' | 'rotate' | 'copy' | 'check' | 'settings' | 'users' | 'share'
  | 'dice' | 'grid' | 'triangle'
  | 'bomb' | 'gem' | 'headset' | 'coin' | 'qr' | 'lock';

const ICONS: Record<IconName, string | string[]> = {
  home:       'M3 11l9-7 9 7v9a2 2 0 0 1-2 2h-4v-6h-6v6H5a2 2 0 0 1-2-2z',
  search:     'M11 4a7 7 0 1 0 4.95 11.95L21 21M11 4a7 7 0 0 1 7 7',
  wallet:     'M3 6h18v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM3 10h18M16 14h2',
  gift:       ['M20 12V8H4v4', 'M2 8h20a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z', 'M12 22V8M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8', 'M9 6a3 3 0 1 1 3-3 3 3 0 0 1 3 3'],
  history:    ['M3 12a9 9 0 1 0 3-6.7L3 8', 'M3 3v5h5', 'M12 7v5l3 2'],
  user:       ['M12 8a4 4 0 1 0-4-4 4 4 0 0 0 4 4z', 'M4 21a8 8 0 0 1 16 0'],
  logout:     ['M16 17l5-5-5-5', 'M21 12H9', 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4'],
  arrowDown:  ['M12 4v14', 'M5 13l7 7 7-7'],
  arrowUp:    ['M12 20V6', 'M5 11l7-7 7 7'],
  arrowRight: ['M5 12h14', 'M13 5l7 7-7 7'],
  close:      ['M6 6l12 12', 'M6 18L18 6'],
  menu:       ['M3 6h18', 'M3 12h18', 'M3 18h18'],
  bell:       'M6 8a6 6 0 0 1 12 0v5l2 3H4l2-3zm3 8a3 3 0 0 0 6 0',
  star:       'M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z',
  play:       'M8 5v14l11-7L8 5z',
  cherry:     'M12 8a8 8 0 0 1 8 8 4 4 0 0 1-8 0 4 4 0 0 1-8 0 8 8 0 0 1 8-8zM12 8V3l3-1M12 8L9 4',
  spade:      'M12 2C8 7 4 10 4 14a4 4 0 0 0 7 3l-1 5h4l-1-5a4 4 0 0 0 7-3c0-4-4-7-8-12z',
  fish:       'M2 12s4-6 11-6c4 0 7 2 9 4l-2 2 2 2c-2 2-5 4-9 4-7 0-11-6-11-6zm14 0h.01',
  video:      'M3 6a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm18 0l-5 4v4l5 4z',
  trendUp:    'M3 17l6-6 4 4 8-8M14 7h7v7',
  ticket:     ['M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z', 'M13 5v2', 'M13 11v2', 'M13 17v2'],
  rotate:     'M3 12a9 9 0 1 1 3 6.7L3 16M3 21v-5h5',
  copy:       ['M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2v-3', 'M14 1H6a2 2 0 0 0-2 2v14h12V3a2 2 0 0 0-2-2z'],
  check:      'M5 12l5 5L20 7',
  settings:   ['M12 20a2 2 0 0 0 2-2 2 2 0 0 0-2-2 2 2 0 0 0-2 2 2 2 0 0 0 2 2zM19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z'],
  users:      ['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M23 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75'],
  share:      ['M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8', 'M16 6l-4-4-4 4', 'M12 2v13'],
  dice:       ['M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z', 'M8 8h.01', 'M16 8h.01', 'M8 16h.01', 'M16 16h.01', 'M12 12h.01'],
  grid:       ['M3 3h7v7H3z', 'M14 3h7v7h-7z', 'M14 14h7v7h-7z', 'M3 14h7v7H3z'],
  triangle:   'M12 3l9 16H3z',
  bomb:       ['M11 4a1 1 0 0 1 2 0v2', 'M13 6l3-3', 'M10 22a7 7 0 1 0 0-14 7 7 0 0 0 0 14z'],
  gem:        ['M6 3h12l3 6-9 12L3 9z', 'M3 9h18', 'M9 3l3 6 3-6', 'M12 9l-3 12M12 9l3 12'],
  headset:    ['M4 14v-3a8 8 0 0 1 16 0v3', 'M4 14a2 2 0 0 1 2-2h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2z', 'M20 14a2 2 0 0 0-2-2h-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1a2 2 0 0 0 2-2z', 'M20 17v1a3 3 0 0 1-3 3h-3'],
  coin:       ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z'],
  lock:       ['M5 11h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1z', 'M8 11V7a4 4 0 0 1 8 0v4'],
  qr:         ['M4 4h6v6H4z', 'M14 4h6v6h-6z', 'M4 14h6v6H4z', 'M14 14h2v2h-2z', 'M18 14h2v2h-2z', 'M14 18h2v2h-2z', 'M18 18h2v2h-2z'],
};

export interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
}

export function Icon({ name, size = 20, className }: IconProps) {
  const d = ICONS[name];
  if (!d) return null;
  const paths = Array.isArray(d) ? d : [d];
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn(className)}
      aria-hidden="true"
    >
      {paths.map((p, i) => (
        <path key={i} d={p} />
      ))}
    </svg>
  );
}
